export default __webpack_public_path__ + "static/media/CustomerCase22.9abc6528.png";